/**
 * Asset/Amenity Constants - Ánh xạ icon và tên cho tất cả 131 amenities
 * Được sử dụng bởi tất cả Asset components để hiển thị amenities đúng cách
 */

// Icon mapping cho tất cả amenities
export const AMENITY_ICON_MAP: Record<string, string> = {
  // === BASIC (12) ===
  'wifi': 'fas fa-wifi',
  'aircon': 'fas fa-snowflake',
  'air_conditioner': 'fas fa-snowflake',
  'tv': 'fas fa-tv',
  'washer': 'fas fa-water',
  'washing_machine': 'fas fa-water',
  'fridge': 'fas fa-ice-cream',
  'refrigerator': 'fas fa-ice-cream',
  'balcony': 'fas fa-door-open',
  'parking': 'fas fa-square-parking',
  'elevator': 'fas fa-arrow-up-arrow-down',
  'security': 'fas fa-shield',
  'gym': 'fas fa-dumbbell',
  'pool': 'fas fa-water',
  'garden': 'fas fa-leaf',
  
  // === APARTMENT ===
  'common_area': 'fas fa-building',
  'childcare': 'fas fa-child',
  'market': 'fas fa-shopping-cart',
  
  // === KITCHEN & DINING ===
  'kitchen': 'fas fa-kitchen-set',
  'modern_kitchen': 'fas fa-kitchen-set',
  'full_kitchen': 'fas fa-kitchen-set',
  'premium_kitchen': 'fas fa-kitchen-set',
  'amusing_kitchen': 'fas fa-fire',
  
  // === OUTDOOR AREAS ===
  'yard': 'fas fa-tree',
  'spacious_yard': 'fas fa-tree',
  'spacious_backyard': 'fas fa-tree',
  'outdoor_space': 'fas fa-tree',
  'rooftop_terrace': 'fas fa-door-open',
  'open_space': 'fas fa-rectangle-landscape',
  'master_terrace': 'fas fa-door-open',
  'rooftop_access': 'fas fa-door-open',
  
  // === WATER & UTILITIES ===
  'water': 'fas fa-water',
  'water_tank': 'fas fa-water',
  'water_well': 'fas fa-water',
  'electricity': 'fas fa-bolt',
  'solar': 'fas fa-sun',
  'backup_power': 'fas fa-bolt',
  'power': 'fas fa-bolt',
  'utilities_included': 'fas fa-plug',
  
  // === BATHROOM & SANITATION ===
  'bathroom': 'fas fa-bath',
  'private_bathroom': 'fas fa-bath',
  'private_toilet': 'fas fa-toilet',
  'customer_wc': 'fas fa-toilet',
  'multiple_bathrooms': 'fas fa-bath',
  'luxury_bathroom': 'fas fa-bath',
  'auto_cleaning': 'fas fa-spray-can',
  
  // === PARKING & VEHICLES ===
  'garage': 'fas fa-warehouse',
  'private_garage': 'fas fa-warehouse',
  'underground_parking': 'fas fa-warehouse',
  'parking_nearby': 'fas fa-square-parking',
  'container_parking': 'fas fa-warehouse',
  
  // === ENTERTAINMENT & LEISURE ===
  'sauna': 'fas fa-spa',
  'sauna_steam': 'fas fa-spa',
  'tennis_court': 'fas fa-baseball',
  'cinema': 'fas fa-film',
  'cinema_room': 'fas fa-film',
  'yoga_wellness': 'fas fa-person-hiking',
  'jacuzzi': 'fas fa-water',
  'infinity_pool': 'fas fa-water',
  
  // === GARDEN & FARMING ===
  'hanging_garden': 'fas fa-leaf',
  'large_garden': 'fas fa-leaf',
  'multi_level_garden': 'fas fa-leaf',
  'agricultural_land': 'fas fa-mountain',
  'greenery': 'fas fa-leaf',
  'irrigation_system': 'fas fa-shower',
  
  // === WORKSPACE & OFFICE ===
  'meeting_room': 'fas fa-door-open',
  'cafe': 'fas fa-mug-hot',
  'reception': 'fas fa-bell',
  'printer': 'fas fa-print',
  'study_room': 'fas fa-briefcase',
  'study_lounge': 'fas fa-sofa',
  'workspace': 'fas fa-laptop',
  'master_bedroom': 'fas fa-bed',
  'spacious_living': 'fas fa-sofa',
  
  // === SHOP & RETAIL ===
  'display': 'fas fa-storefront',
  'cashier': 'fas fa-cash-register',
  'storage': 'fas fa-warehouse',
  'fitting_room': 'fas fa-door-open',
  'entrance': 'fas fa-door-open',
  
  // === WAREHOUSE & LOGISTICS ===
  'loading_area': 'fas fa-arrows',
  'forklift': 'fas fa-hammer',
  'sprinkler': 'fas fa-fire-extinguisher',
  'outdoor_storage': 'fas fa-warehouse',
  'storage_room': 'fas fa-warehouse',
  
  // === SMART HOME & AUTOMATION ===
  'smart_ac': 'fas fa-snowflake',
  'smart_lighting': 'fas fa-lightbulb',
  'smart_home': 'fas fa-microchip',
  'smart_home_system': 'fas fa-microchip',
  'home_automation': 'fas fa-microchip',
  'smart_elevator': 'fas fa-arrow-up-arrow-down',
  'smart_wifi': 'fas fa-wifi',
  'privacy_lock': 'fas fa-key',
  'security_system': 'fas fa-shield',
  'advanced_security': 'fas fa-lock',
  
  // === OUTDOOR FURNITURE & DECOR ===
  'lounge_chairs': 'fas fa-chair',
  'premium_bbq': 'fas fa-fire',
  'outdoor_speakers': 'fas fa-volume-up',
  'retractable_awning': 'fas fa-umbrella',
  'outdoor_wifi': 'fas fa-wifi',
  'outdoor_minibar': 'fas fa-wine-glass',
  'outdoor_heater': 'fas fa-sun',
  'modern_furniture': 'fas fa-sofa',
  'premium_bed': 'fas fa-bed',
  'sound_system': 'fas fa-volume-up',
  'private_bar': 'fas fa-wine-glass',
  'wine_cellar': 'fas fa-wine-glass-alt',
  
  // === LOCATION & ACCESS ===
  'access_road': 'fas fa-road',
  'flat': 'fas fa-square',
  'close_to_school': 'fas fa-school',
  'nature_view': 'fas fa-tree',
  'view_360': 'fas fa-binoculars',
  'high_visibility': 'fas fa-location-dot',
  
  // === AGRICULTURE & FARMING ===
  'livestock_barn': 'fas fa-horse',
  
  // === SECURITY & SERVICES ===
  'locker': 'fas fa-lock',
  'laundry': 'fas fa-shirt',
  '24_7_guard': 'fas fa-shield-alt',
  'security_24_7': 'fas fa-shield-alt',
  'concierge_service': 'fas fa-bell',
  'concierge_24_7': 'fas fa-bell',
  'gym_access': 'fas fa-dumbbell',
  
  // === UNIQUE / SPECIALIZED ===
  'helipad': 'fas fa-plane',
  'fireplace': 'fas fa-fire',
  'heating': 'fas fa-fire',
  'independent_hvac': 'fas fa-snowflake',
  'usb_charging': 'fas fa-plug',
  'mini_fridge': 'fas fa-ice-cream',
  'vending_machine': 'fas fa-vial',
  'checkout_24_7': 'fas fa-door-open',
  'air_quality': 'fas fa-wind',
  
  // === FLEXIBLE WORKSPACE ===
  'flexible_space': 'fas fa-rectangle-landscape',
  'modern_fixtures': 'fas fa-tools',
  'quick_setup': 'fas fa-hammer',
  'weather_protection': 'fas fa-umbrella',
  'easy_permit': 'fas fa-file',
};

// Name mapping cho tất cả amenities
export const AMENITY_NAME_MAP: Record<string, string> = {
  // === BASIC (12) ===
  'wifi': 'Wifi',
  'aircon': 'Điều hòa',
  'air_conditioner': 'Điều hòa',
  'tv': 'Tivi',
  'washer': 'Máy giặt',
  'washing_machine': 'Máy giặt',
  'fridge': 'Tủ lạnh',
  'refrigerator': 'Tủ lạnh',
  'balcony': 'Ban công',
  'parking': 'Chỗ để xe',
  'elevator': 'Thang máy',
  'security': 'Bảo vệ 24/7',
  'gym': 'Phòng gym',
  'pool': 'Hồ bơi',
  'garden': 'Vườn',
  
  // === APARTMENT ===
  'common_area': 'Khu vực chung',
  'childcare': 'Khu vui chơi trẻ em',
  'market': 'Siêu thị',
  
  // === KITCHEN & DINING ===
  'kitchen': 'Bếp',
  'modern_kitchen': 'Bếp hiện đại',
  'full_kitchen': 'Bếp đầy đủ',
  'premium_kitchen': 'Bếp cao cấp',
  'amusing_kitchen': 'Bếp giải trí ngoài trời',
  
  // === OUTDOOR AREAS ===
  'yard': 'Sân',
  'spacious_yard': 'Sân rộng',
  'spacious_backyard': 'Sân sau rộng',
  'outdoor_space': 'Không gian ngoài trời',
  'rooftop_terrace': 'Sân thượng/Terace',
  'open_space': 'Không gian mở rộng',
  'master_terrace': 'Sân thượng riêng',
  'rooftop_access': 'Truy cập sân thượng',
  
  // === WATER & UTILITIES ===
  'water': 'Nước',
  'water_tank': 'Bể nước',
  'water_well': 'Giếng nước',
  'electricity': 'Điện',
  'solar': 'Pin mặt trời',
  'backup_power': 'Máy phát điện',
  'power': 'Điện công nghiệp',
  'utilities_included': 'Điện nước đủ cấp',
  
  // === BATHROOM & SANITATION ===
  'bathroom': 'Phòng tắm chung',
  'private_bathroom': 'Phòng tắm riêng',
  'private_toilet': 'Toilet riêng',
  'customer_wc': 'WC khách',
  'multiple_bathrooms': 'Nhiều phòng tắm',
  'luxury_bathroom': 'Phòng tắm sang trọng',
  'auto_cleaning': 'Vệ sinh tự động',
  
  // === PARKING & VEHICLES ===
  'garage': 'Garage',
  'private_garage': 'Garage riêng',
  'underground_parking': 'Garage ngầm',
  'parking_nearby': 'Chỗ đậu xe gần',
  'container_parking': 'Bãi đậu container',
  
  // === ENTERTAINMENT & LEISURE ===
  'sauna': 'Sauna',
  'sauna_steam': 'Phòng sauna & hơi nước',
  'tennis_court': 'Sân tennis',
  'cinema': 'Phòng chiếu phim',
  'cinema_room': 'Phòng chiếu phim 4K',
  'yoga_wellness': 'Phòng yoga/wellness',
  'jacuzzi': 'Bể jacuzzi/spa',
  'infinity_pool': 'Hồ bơi vô cực',
  
  // === GARDEN & FARMING ===
  'hanging_garden': 'Vườn treo',
  'large_garden': 'Vườn cây lớn',
  'multi_level_garden': 'Vườn nhiều tầng',
  'agricultural_land': 'Đất nông nghiệp',
  'greenery': 'Cây xanh',
  'irrigation_system': 'Hệ thống tưới cây',
  
  // === WORKSPACE & OFFICE ===
  'meeting_room': 'Phòng họp',
  'cafe': 'Phòng cafe',
  'reception': 'Lễ tân',
  'printer': 'Dịch vụ in ấn',
  'study_room': 'Phòng làm việc',
  'study_lounge': 'Phòng lounge',
  'workspace': 'Khu vực làm việc',
  'master_bedroom': 'Phòng ngủ master',
  'spacious_living': 'Phòng khách rộng',
  
  // === SHOP & RETAIL ===
  'display': 'Khu trưng bày',
  'cashier': 'Quầy thu ngân',
  'storage': 'Kho hàng',
  'fitting_room': 'Phòng thử đồ',
  'entrance': 'Mặt tiền đường chính',
  
  // === WAREHOUSE & LOGISTICS ===
  'loading_area': 'Khu dỡ hàng',
  'forklift': 'Cầu nâng',
  'sprinkler': 'Hệ thống PCCC',
  'outdoor_storage': 'Kho ngoài trời',
  'storage_room': 'Kho lưu trữ',
  
  // === SMART HOME & AUTOMATION ===
  'smart_ac': 'Điều hòa thông minh',
  'smart_lighting': 'Chiếu sáng thông minh',
  'smart_home': 'Nhà thông minh',
  'smart_home_system': 'Hệ thống nhà thông minh',
  'home_automation': 'Nhà tự động',
  'smart_elevator': 'Thang máy thông minh',
  'smart_wifi': 'Wifi tốc độ cao 5G',
  'privacy_lock': 'Khóa thông minh',
  'security_system': 'Hệ thống an ninh',
  'advanced_security': 'Hệ thống an ninh cao cấp',
  
  // === OUTDOOR FURNITURE & DECOR ===
  'lounge_chairs': 'Ghế lounge cao cấp',
  'premium_bbq': 'Khu BBQ cao cấp',
  'outdoor_speakers': 'Âm thanh ngoài trời',
  'retractable_awning': 'Che nắng tự động',
  'outdoor_wifi': 'Wifi ngoài trời',
  'outdoor_minibar': 'Minibar ngoài trời',
  'outdoor_heater': 'Sưởi ngoài trời',
  'modern_furniture': 'Nội thất hiện đại',
  'premium_bed': 'Giường cao cấp',
  'sound_system': 'Hệ thống âm thanh',
  'private_bar': 'Bar riêng tư',
  'wine_cellar': 'Tủ rượu thông minh',
  
  // === LOCATION & ACCESS ===
  'access_road': 'Đường vào',
  'flat': 'Bằng phẳng',
  'close_to_school': 'Gần trường học',
  'nature_view': 'Gần thiên nhiên',
  'view_360': 'View 360 độ',
  'high_visibility': 'Vị trí lưu lượng cao',
  
  // === AGRICULTURE & FARMING ===
  'livestock_barn': 'Chuồng trại',
  
  // === SECURITY & SERVICES ===
  'locker': 'Tủ khóa',
  'laundry': 'Giặt ủi',
  '24_7_guard': 'Bảo vệ 24/7',
  'security_24_7': 'Bảo vệ 24/7',
  'concierge_service': 'Dịch vụ concierge',
  'concierge_24_7': 'Dịch vụ concierge 24/7',
  'gym_access': 'Truy cập phòng gym',
  
  // === UNIQUE / SPECIALIZED ===
  'helipad': 'Đáp máy bay',
  'fireplace': 'Lò sưởi',
  'heating': 'Sưởi ấm',
  'independent_hvac': 'Hệ thống điều hòa độc lập',
  'usb_charging': 'Cổng sạc USB',
  'mini_fridge': 'Tủ lạnh mini',
  'vending_machine': 'Máy bán hàng',
  'checkout_24_7': 'Check-in/out 24/7',
  'air_quality': 'Hệ thống lọc không khí',
  
  // === FLEXIBLE WORKSPACE ===
  'flexible_space': 'Không gian linh hoạt',
  'modern_fixtures': 'Trang thiết bị hiện đại',
  'quick_setup': 'Dễ dàng bố trí',
  'weather_protection': 'Khung chịu thời tiết',
  'easy_permit': 'Dễ xin phép',
};

// Combined info map for carousel-style components
export const AMENITY_INFO_MAP: Record<string, { icon: string; name: string }> = {};

// Build AMENITY_INFO_MAP from AMENITY_ICON_MAP and AMENITY_NAME_MAP
Object.keys(AMENITY_ICON_MAP).forEach((key) => {
  AMENITY_INFO_MAP[key] = {
    icon: AMENITY_ICON_MAP[key],
    name: AMENITY_NAME_MAP[key] || key,
  };
});
